
import { React, useState, useEffect, Name_Regex, Email_Regex, SelectChangeEvent } from '../../utils/globalImports';
import { Dialog, DialogActions, FormControlLabel, Checkbox, CloseIcon, DialogContent, DialogTitle, Divider, IconButton, Typography, Box, PhoneInput } from '../../utils/globalImports';
import { CustomButton, CustomTextField, CustomDropdown, CustomRadioButton, ContactType, ContactTypeId, validationMessages } from '../../utils/globalImports';
import { validateField, validationPatterns } from '../../utils/validationUtils';

interface Contact {
    name?: string;
    contactType?: number;
    firstName: string;
    lastName: string;
    mobileNo: string;
    isPrimary: boolean;
    primary?: string;
    emailAddress: string;
    email?: string;
    phone?: string;
    conttactTypeId?: number;
    status: string;
    Status?: string;
    office: string;
    role: string;
}

interface ModalProps {
    open: boolean;  // Prop to determine if the modal is open
    onClose: (closeConfirmationRequired: boolean) => void;  // Function to handle modal close
    onSubmit: (formData: Contact) => void;
    contactData?: Contact; // Optional prop for editing a user
    handleContentChange: (state: boolean) => void;
}

interface Option {
    value: string | number;
    text: string;
}

const CustomAddContactModal: React.FC<ModalProps> = ({ open, onClose, onSubmit, contactData, handleContentChange }) => {
    // State to handle modal visibility

    const [contactType, setContactType] = useState<Option[]>([]);

    // Form data state
    const [formData, setFormData] = useState<Contact>({
        role: '',
        firstName: '',
        lastName: '',
        mobileNo: '',
        emailAddress: '',
        isPrimary: false,
        status: 'Active',
        office: ''
    });

    const [errors, setErrors] = useState({
        role: '',
        firstName: '',
        lastName: '',
        mobileNo: '',
        email: '',
    });

    useEffect(() => {
        // fetchContactType()

        if (open) {
            if (contactData && contactData.name) {
                const [firstName, lastName] = contactData.name.split(' ');
                setFormData({
                    firstName: firstName || '',
                    lastName: lastName || '',
                    emailAddress: contactData.email || '',
                    mobileNo: contactData.phone || '',
                    isPrimary: contactData.primary === 'No' ? false : true,
                    // contactType: contactData.conttactTypeId || -1,
                    status: contactData.Status || 'Active',
                    office: contactData.office,
                    role: contactData.role
                });
            } else {
                setFormData({
                    firstName: '',
                    lastName: '',
                    emailAddress: '',
                    mobileNo: '',
                    isPrimary: false,
                    // contactType: -1,
                    status: 'Active',
                    office: '',
                    role: ''
                });
            }
            setErrors({
                role: '',
                firstName: '',
                lastName: '',
                mobileNo: '',
                email: '',
            });
        }


    }, [open, contactData]);

    useEffect(() => {
        if (!open) {
            setFormData({
                role: '',
                firstName: '',
                lastName: '',
                emailAddress: '',
                mobileNo: '',
                isPrimary: false,
                status: 'Active',
                office: ''
            });
        }
    }, [open]);


    // fetch ContactType
    const fetchContactType = async () => {
        const categoryOptions = Object.entries(ContactType).map(([id, description]) => ({
            value: id,  // Ensure `id` exists in the response
            text: description, // Ensure `name` exists in the response
        }))
            .sort((a, b) => a.text.localeCompare(b.text));
        setContactType(categoryOptions);
    }


    // validate form field
    const validate = () => {



        let isValid = true;
        const errors = { role: '', firstName: '', lastName: '', mobileNo: '', email: '' };

        errors.role = validateField(formData.role, {
            fieldName: "Role",
            required: true,
        });

        if (errors.role) isValid = false;


        errors.firstName = validateField(formData.firstName, {
            fieldName: "First name",
            required: true,
            pattern: validationPatterns.alphaWithHyphen
        });
        if (errors.firstName) isValid = false;


        // ⭐ Last Name validation (converted)
        errors.lastName = validateField(formData.lastName, {
            fieldName: "Last name",
            required: true,
            pattern: validationPatterns.alphaWithHyphen
        });
        if (errors.lastName) isValid = false;

        // if (!formData.mobileNo) {
        //     errors.mobileNo = validationMessages.common_required("mobile no");
        //     isValid = false;
        // }
        // else if (!mobileRegex.test(formData.mobileNo)) {
        //     errors.mobileNo = validationMessages.common_phone;
        //     isValid = false;
        // }

        if (!formData.emailAddress) {
            errors.email = validationMessages.common_required("Email");
            isValid = false;
        }
        else if (!Email_Regex.test(formData.emailAddress)) {
            errors.email = validationMessages.common_email("Client");
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    };

    // Handle form submission
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            onSubmit(formData);
            // onClose(); // Close modal after submit
        }
    };

    // Handle form data change
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, checked, type } = e.target;

        // Toggle checkbox state on change
        if (type === "checkbox") {
            setFormData((prevData) => ({
                ...prevData,
                [name]: checked, // Toggle the checkbox value
            }));
            handleContentChange(true);
        } else {
            // For text fields, update the value
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
            handleContentChange(true);
        }
    };

    const handleRoleChage = (event: SelectChangeEvent<string | number>) => {
        setFormData((prevData) => ({
            ...prevData,
            contactType: Number(event.target.value),
        }));
        handleContentChange(true)
    }




    return (
        <div>

            {/* Modal Dialog */}
            <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle
                    sx={{
                        position: 'relative',
                        color: '#1e66ab',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 0,
                        fontWeight: 500,
                        fontSize: '22px'
                    }}>
                    {contactData ? 'Edit Contact' : 'Add Contact'}
                    <IconButton
                        color="inherit"
                        onClick={() => onClose(true)}
                        sx={{
                            position: 'absolute',
                            right: 8, // Position the button at the right
                            top: 8,   // Position the button at the top
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider></Divider>

                <DialogContent sx={{ ml: 2, mr: 2 }}>
                    <form onSubmit={handleSubmit}>


                        <Box sx={{ mb: 1 }}>
                            <CustomTextField
                                label="First Name"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                sx={{ mb: 1 }}
                                required={true}
                            />
                            {errors.firstName && (
                                <Typography className="validationMessage" role="alert">
                                    {errors.firstName}
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{ mb: 1 }}>
                            <CustomTextField
                                label="Last Name"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                sx={{ mb: 1 }}
                                required={true}
                            />
                            {errors.lastName && (
                                <Typography className="validationMessage" role="alert">
                                    {errors.lastName}
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{ mb: 1 }}>
                            {/* <CustomDropdown
                                value={formData.contactType}
                                onChange={handleRoleChage}
                                label="Job Role"
                                options={contactType}
                                requiredLabel={true}
                                sx={{ mb: 1, height: '35px', fontSize: '12px' }}
                            /> */}
                            <CustomTextField
                                label="Job Role"
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                sx={{ mb: 1 }}
                                required={true}
                            />

                            {errors.role && (
                                <Typography className="validationMessage" role="alert">
                                    {errors.role}
                                </Typography>
                            )}
                        </Box>

                        <Box sx={{ mb: 1 }}>
                            <CustomTextField
                                label="Email Address"
                                name="emailAddress"
                                type="email"
                                value={formData.emailAddress}
                                onChange={handleChange}
                                sx={{ mb: 1 }}
                                required={true}
                            />
                            {errors.email && (
                                <Typography className="validationMessage" role="alert">
                                    {errors.email}
                                </Typography>
                            )}
                        </Box>


                        <Typography variant="subtitle1" sx={{ display: 'block', color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1 }}>
                            Phone No.
                            {/* {<span style={{ color: 'red' }}>*</span>} */}
                        </Typography>
                        <Box sx={{ mb: 1 }}>
                            <PhoneInput
                                key={contactData ? 'edit' : 'add'}
                                country={"gb"}
                                enableSearch
                                value={formData.mobileNo || ''}
                                onChange={(phone) => {
                                    setFormData((prevData) => ({
                                        ...prevData,
                                        mobileNo: phone || '',
                                    }));
                                    handleContentChange(true);
                                }}
                                inputStyle={{
                                    width: "100%",
                                    borderRadius: "50px",
                                    height: "35px",
                                    paddingLeft: "50px",
                                    fontSize: "14px",
                                    marginBottom: "6px"
                                }}
                                containerStyle={{
                                    width: "100%",
                                }}
                            />
                            {/* {errors.mobileNo && (
                                <Typography className="validationMessage" role="alert">
                                    {errors.mobileNo}
                                </Typography>
                            )} */}
                        </Box>





                        <CustomTextField
                            label="Office"
                            name="office"
                            value={formData.office}
                            onChange={handleChange}
                            sx={{ mb: 2 }}
                        />

                        {contactData && (
                            <>
                                <Typography sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1, mt: 1 }}>Status</Typography>
                                <Box sx={{ display: 'flex' }}>
                                    <CustomRadioButton
                                        label="Active"
                                        value="Active"
                                        name="status"
                                        checked={formData.status === 'Active'}
                                        onChange={handleChange}
                                        required={true}
                                    />
                                    <CustomRadioButton
                                        label="Inactive"
                                        value="Inactive"
                                        name="status"
                                        checked={formData.status === 'Inactive'}
                                        onChange={handleChange}
                                        required={true}
                                    />
                                </Box>
                            </>
                        )}

                        {/* Checkbox */}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="isPrimary"
                                    checked={formData.isPrimary}
                                    onChange={handleChange}
                                    color="primary"
                                    size="small"

                                />
                            }
                            label="Primary"

                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    color: '#1e66ab', // Customize label color
                                    fontSize: '14px', // Adjust font size of the label text
                                    fontWeight: 500
                                }
                            }}
                        />
                    </form>

                </DialogContent>
                <DialogActions sx={{ mb: 3 }}>
                    {/* Add User */}
                    <CustomButton
                        capsule
                        sx={{
                            mt: 2,
                            mb: 2,
                            textTransform: 'none',
                            width: '60%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '0 auto', // Centers horizontally if parent has `display: block`
                        }}
                        onClick={handleSubmit}
                    >
                        {contactData ? 'Update Contact' : 'Add Contact'}
                    </CustomButton>
                </DialogActions>
            </Dialog>
        </div >
    );
};

export default CustomAddContactModal;
